// extracted by mini-css-extract-plugin
module.exports = {"mobile":"360","tablet":"768","desktop":"1280","cls1":"_1SYJ2","cls2":"_3ktGS","cls4":"idkVn","cls6":"_3-jbE"};